export default __webpack_public_path__ + "static/media/OneviewWhite.7eea62f4.webp";